<template>
    <div class="editPwdWrap">
        <div class="breadBox">
            <div class="breadItem"><span>修改密码 <span> {{phone}}</span> </span></div>
        </div>
        <div class="content">
            <div class="formWrap" v-loading="isLoading" >
                <el-tabs type="border-card">
                    <el-tab-pane label="验证码修改">
                        <el-form ref="formCode" :model="formCodeObj" label-width="120px">
                            <el-form-item label="手机号" prop='phone' required class="inputLine">
                                <el-input v-model="formCodeObj.phone" placeholder="输入手机号" clearable disabled autocomplete="off"></el-input>
                                <el-button class="rightBtn"   @click="sendCode" size="mini" :disabled="isDisabledCode">{{codeMsg}}</el-button>
                            </el-form-item>
                            
                            <el-form-item label="新密码" prop='newPwd' required>
                                <el-input v-model="formCodeObj.newPwd" placeholder="输入新密码" show-password autocomplete="off"></el-input>
                            </el-form-item>
                             <el-form-item label="确认新密码" prop='newPwd2' required>
                                <el-input v-model="formCodeObj.newPwd2" placeholder="请再次确认新密码" show-password autocomplete="off"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码" prop='code' required>
                                <el-input v-model="formCodeObj.code" placeholder="输入验证码" autocomplete="off"></el-input>
                            </el-form-item>
                             <el-form-item>
                                 <el-button type="primary" @click="submitClick('formCode')">确认修改</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                  <el-tab-pane label="通过密码修改">
                      <el-form ref="formPwd" :model="formPwdObj" label-width="120px">
                          <el-form-item label="账号" prop='phone' required>
                              <el-input v-model="formPwdObj.phone" placeholder="输入当前用户手机号" disabled autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="旧密码" prop='oldPwd' required>
                              <el-input v-model="formPwdObj.oldPwd" placeholder="输入旧密码" show-password autocomplete="off"></el-input>
                          </el-form-item>
                          <el-form-item label="新密码" prop='newPwd' required>
                              <el-input v-model="formPwdObj.newPwd" placeholder="输入新密码" show-password autocomplete="off"></el-input>
                          </el-form-item>
                           <el-form-item label="确认新密码" prop='newPwd2' required>
                              <el-input v-model="formPwdObj.newPwd2" placeholder="请再次确认新密码" show-password autocomplete="off"></el-input>
                          </el-form-item>
                           <el-form-item>
                               <el-button type="primary"  @click="submitClick_Pwd('formPwd')">确认修改</el-button>
                          </el-form-item>
                      </el-form>
                  </el-tab-pane>
                  
                </el-tabs>
            </div>
            
           
        </div>

    </div>

</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxLogin,        api    } from '@/common/request.js'
    export default {
        name: 'editPwd',
        data() {
            return {
                isLoading:false,
                formPwdObj:{
                    phone:'',
                },
                formCodeObj:{
                    phone:'',
                },
                isDisabledCode:false,
                codeMsg:'发送验证码'
            }
        },
        computed: {
            adminId() {
                return utils.getAdminId()
            },
            phone(){
                this.formPwdObj.phone=utils.getPhone()
                this.formCodeObj.phone=utils.getPhone()
               return utils.getPhone()
            }
        },
        methods: {
            sendCode(){
                let _this = this
                const reg = /^1(3|4|5|6|7|8|9)[0-9]{9}$/
                if(! reg.test(this.formCodeObj.phone)){
                    _this.$message({
                    	message: "手机号码格式不正确1", 
                    	type: 'error',
                    	duration: 1500
                    });
                }else  if (!_this.isDisabledCode) {
                    let num = 60
                    _this.codeMsg = '已发送' + num + 's'
                    _this.isDisabledCode = true
                    let arg={phone:_this.formCodeObj.phone}
                    ajaxLogin('/admin/yijiajiaUserInfo/RequestPhoneCode', arg).then(function(res) {
                        if (res.errorCode == 200) {
                            _this.$message({
                            	message: "发送成功",
                                type:'success',
                            	duration: 1500
                            });
                        }
                    }, function(res) {
                    })
                    
                    let timer = setInterval(function() {
                        if (num > 1) {
                            num--
                            _this.codeMsg = '已发送' + num + 's'
                            _this.isDisabledCode = true
                        } else {
                            _this.codeMsg = '发送验证码'
                            _this.isDisabledCode = false
                            clearInterval(timer)
                            timer = null
                        }
                    }, 1000)
                }
            },
            submitClick_Pwd(formName){//通过旧密码修改
                let _this=this
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                      if(_this.formPwdObj.newPwd!=_this.formPwdObj.newPwd2){
                         _this.$message({
                        	message: "两次密码不一致",
                            type:'error',
                        });  
                      }else{
                          _this.isLoading=true
                          let arg={
                               "createAdminId":_this.adminId,
                               "phone":_this.formPwdObj.phone,
                               "oldPwd":_this.formPwdObj.oldPwd,
                               "adminPasswd":_this.formPwdObj.newPwd,
                               "checkPassWd":_this.formPwdObj.newPwd2,
                          }
                          ajaxLogin('/admin/user/editUserInfoPwd', arg).then(function(res) {
                               setTimeout(function(){
                                  _this.isLoading=false
                              },500)
                              if (res.errorCode == 200) {
                                  _this.$message({
                                  	message: "修改成功",
                                      type:'success',
                                  	duration: 3000
                                  });
                              } else{
                                   
                              }
                          }, function(res) {
                               setTimeout(function(){
                                  _this.isLoading=false
                              },500)
                          })
                      }
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
            },
            submitClick(formName){
                let _this=this
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                      if(_this.formCodeObj.newPwd!=_this.formCodeObj.newPwd2){
                         _this.$message({
                        	message: "两次密码不一致",
                            type:'error',
                        });  
                      }else{
                           _this.isLoading=true
                          let arg={
                               "createAdminId":_this.adminId,
                               "phone":_this.formCodeObj.phone,
                               "adminPasswd":_this.formCodeObj.newPwd,
                               "checkPassWd":_this.formCodeObj.newPwd2,
                               "code":_this.formCodeObj.code
                          }
                          ajaxLogin('/admin/user/editUserPwd', arg).then(function(res) {
                               setTimeout(function(){
                                  _this.isLoading=false
                              },500)
                              if (res.errorCode == 200) {
                                  _this.$message({
                                  	message: "修改成功",
                                      type:'success',
                                  	duration: 3000
                                  });
                              } else{
                              }
                          }, function(res) {
                              setTimeout(function(){
                                 _this.isLoading=false
                             },500)
                          })
                      }
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
            }
        },
        mounted() {
            let _this = this
        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid blue;}
    .editPwdWrap {
        .formWrap{width: 500px;}
        .inputLine{
            position: relative;
            .rightBtn{
                position: absolute;right:5px;top:7px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/commonPage/editPwd.vue